"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  addressType: 'Москва, Ленинский проспект 147',
  hoaType: 'ТСН Зеленая опушка'
};